import React, { useEffect, useState } from "react";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { useSortBy, useTable } from "react-table";
import {Last24HourTransApi, TerminalLocationDataTableViewApi} from "../Api";
import axios from "axios";


function Last24HourTrans() {
  const location = useLocation();
    const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
  const [data, setData] = useState([]);
  const columns = [
    {
      Header: "Seq No",
      accessor: "seqNo",
    },
    {
      Header: "Tran Time",
      accessor: "tranTime",
    },
    {
      Header: "Type",
      accessor: "type",
    },
    {
      Header: "From Acct",
      accessor: "fromAcct",
    },
    {
      Header: "Batch Id",
      accessor: "batchID",
    },
    {
      Header: "Pan",
      accessor: "pan",
    },
    {
      Header: "Req Amt",
      accessor: "reqAmt",
    },
    {
      Header: "Disp Amt",
      accessor: "dispAmt",
    },
    {
      Header: "surch Amt",
      accessor: "surchAmt",
    },
    {
      Header: "conv Amt",
      accessor: "convAmt",
    },
    {
      Header: "Auth Amt",
      accessor: "authAmt",
    },
    {
      Header: "Auth Code",
      accessor: "authCode",
    },
    {
      Header: "Auth Msg",
      accessor: "authMsg",
    },
    {
      Header: "ATM Balance",
      accessor: "",
    },
    {
      Header: "Rev Code",
      accessor: "revCode",
    },
    {
      Header: "Rev Reason",
      accessor: "revReason",
    },
    {
      Header: "EMV",
      accessor: "",
    },
  ];
  useEffect(() => {
    const fetchData = async () => {
      const result = await axios.get(`${Last24HourTransApi}?termId=${location.search.split("=")[1]}&startDate=${moment().subtract(1, "day").
      format("MM/DD/YYYY")}&endDate=${moment().format("MM/DD/YYYY")}&batchID=-10&sortOrder=ASC0&userID=${loggedUserStorage}`);
      setData(result.data.response);
    };
    fetchData();
  }, [location.search]);

  function Table({ columns, data }) {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
      useTable(
        {
          columns,
          data,
        },
        useSortBy
      );
    return (
      <>
        <div className="report_table_outer">
          <div className="table-responsive">
            <table
              {...getTableProps()}
              className="table table-bordered w-auto small"
            >
              <thead className="thead-light">
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        {column.render("Header")}
                        <span>
                          {column.isSorted ? (
                            column.isSortedDesc ? (
                              <svg
                                className="th-align-left"
                                focusable="false"
                                xmlns="http://www.w3.org/2000/svg"
                                width="14px"
                                height="14px"
                                fill="currentColor"
                                viewBox="0 0 16 16"
                              >
                                <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                              </svg>
                            ) : (
                              <svg
                                className="th-align-right"
                                focusable="false"
                                xmlns="http://www.w3.org/2000/svg"
                                width="14px"
                                height="14px"
                                fill="currentColor"
                                class="bi bi-caret-up-fill"
                                viewBox="0 0 16 16"
                              >
                                <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />
                              </svg>
                            )
                          ) : (
                            ""
                          )}
                        </span>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows?.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr
                      {...row.getRowProps()}
                      onClick={() => console.log(row.original)}
                    >
                      {row.cells.map((cell) => {
                        return (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="mt-3">
      <h2 className="text-center" style={{color:'#4682b4',fontSize:'20pt'}}><strong>Transaction History LookUp</strong></h2>
      <div className="mt-3">
        <div >
          <h6><strong  style={{color:'#4682b4'}}>{`Date From: ${moment()
              .subtract(1, "day")
              .format("MM/DD/YYYY HH:mm:ss")} , Date To: ${moment().format("MM/DD/YYYY HH:mm:ss")}`}</strong></h6>
          <h6><strong  style={{color:'#4682b4'}}>{`User: ${loggedUserStorage} | Terminal: ${
            location.search.split("=")[1]
          }`}</strong></h6>
        </div>
        <div className="mt-4">
          <Table columns={columns} data={data} />
        </div>
      </div>
    </div>
  );
}

export default Last24HourTrans;
